import React, { Fragment } from 'react';
import { TextArea, Icon } from '@gerdau/hefesto';

import { BoldText } from '../styles';
import { Container, WarningMessage } from './styles';
import { WarningText } from '../styles';
import { ISelectedTableOrders, UpdateErrorMsgMap, UpdateErrorType } from '..';

interface IOtherUpdate {
  loading: boolean;
  otherReason: string;
  setOtherReason: (msg: string, option: string) => void;
  errorMessage: string;
  hasUpdateError: boolean;
  selectedItens: ISelectedTableOrders[];
}

const OtherUpdate: React.FC<IOtherUpdate> = ({
  loading,
  otherReason,
  setOtherReason,
  errorMessage,
  hasUpdateError,
  selectedItens
}) => {
  return (
    <>
      <p>
        <BoldText>Outro</BoldText>
      </p>
      <p>
        Iremos enviar sua solicitação para nossa central de atendimento, que
        entrará em contato através do email cadastrado.
      </p>
      {hasUpdateError && (
        <>
          {selectedItens.map((item) => {
            if (
              item.materials.some(
                (m) =>
                  m.errorType &&
                  (m.errorType === UpdateErrorType.STATUS ||
                    m.errorType === UpdateErrorType.ORDER_TYPE)
              )
            ) {
              return (
                <Fragment key={item.orderNumber}>
                  <WarningText>
                    Para o pedido <strong>{item.orderNumber}</strong> {': '}
                    {item.materials.map((material) => {
                      if (material.errorType) {
                        return (
                          <div
                            key={material.id}
                            style={{ marginBottom: '1rem' }}
                          >
                            <span>
                              O item <strong>{material.description}</strong> não
                              pôde ser alterado porque{' '}
                              <strong>
                                {UpdateErrorMsgMap.get(material.errorType)}
                              </strong>
                            </span>
                            <br />
                          </div>
                        );
                      }
                    })}
                  </WarningText>
                </Fragment>
              );
            }
          })}
          {selectedItens
            .flatMap((items) => items.materials)
            .some(
              (m) =>
                m.errorType &&
                (m.errorType === UpdateErrorType.STATUS ||
                  m.errorType === UpdateErrorType.ORDER_TYPE)
            ) && (
            <WarningText>
              <strong>
                Selecione na tabela apenas o item que pode ser alterado.
              </strong>
            </WarningText>
          )}
        </>
      )}
      <Container>
        <TextArea
          label="Pedido de alteração"
          placeholder="Descreva o que você precisa alterar."
          name="Text area outro motivo"
          minLength={1}
          maxLength={500}
          disabled={loading}
          resizable={false}
          cols={38}
          value={otherReason}
          onChange={(e) => setOtherReason(e.target.value, 'other')}
          rows={8}
        />
        {errorMessage.length ? (
          <WarningMessage>
            <Icon option="Alert" variant="danger" />
            {errorMessage}
          </WarningMessage>
        ) : null}
      </Container>
    </>
  );
};

export default OtherUpdate;
